const GonghuoRouter = {
    path: '/gonghuo', 
    name: 'gonghuo',
    children: [
        {
            path: 'center',
            name: 'center',
            meta: {title: '供货商中心'},
            component: () => import('@/views/gonghuo/center.vue')
        }
    ]
}

export default GonghuoRouter
